import { RevisionBulkActionProps, RevisionRow } from 'components/tables/data/revision/types';

import Button from 'components/Button';
import { IconCheck } from '@tabler/icons-react';
import useApproveAction from 'components/tables/data/revision/actions/hooks/use-approve-action';
import { noop } from 'lodash';
import BulkConfirmMessage from 'components/tables/data/revision/actions/bulk/BulkConfirmMessage';
import { useConfirm } from 'components/modals/message/MessageProvider';
import { getBulkRevisionKindGroup } from 'components/tables/data/revision/actions/bulk/kind-utils';

/**
 * Performs a bulk approve on all selected rows.
 */
export default function BulkApproveAction({
  revisions,
  onStatusChange = noop,
  onBulkActionComplete = noop,
}: RevisionBulkActionProps) {
  const { confirm } = useConfirm();
  const { approveRevision } = useApproveAction();
  const availableRevisions: RevisionRow[] =
    getBulkRevisionKindGroup(revisions) === 'mixed'
      ? []
      : revisions.filter(
          (revision) =>
            revision.revisionStatus.slug === 'finished-waiting-for-approval' && revision.actionPermissions.canApprove
        );

  /**
   * Approves all selected revisions.
   */
  const approveAll = () =>
    confirm({
      title: availableRevisions[0]?.kind === 'revision' ? 'Schváliť revízne správy' : 'Schváliť formuláre',
      content: (
        <BulkConfirmMessage
          message={
            availableRevisions[0]?.kind === 'revision'
              ? 'Naozaj si prajete schváliť vybrané revízne správy?'
              : 'Naozaj si prajete schváliť vybrané formuláre?'
          }
          revisions={availableRevisions}
        />
      ),
      primaryButtonText: 'Schváliť',
      secondaryButtonText: 'Zrušiť',
      onConfirm: async () => {
        for (const revision of availableRevisions) {
          await approveRevision({ revision, onStatusChange });
        }
        onBulkActionComplete();
      },
    });

  if (availableRevisions.length === 0) {
    return <></>;
  }

  return (
    <Button variant="primary" size="sm" leftIcon={<IconCheck />} onClick={approveAll}>
      Schváliť ({availableRevisions.length})
    </Button>
  );
}
